<template>
  <div v-loading="loading" v-if="$canAndRulesPass(user, 'users.user_users_report')">
    <page-heading :heading="pageTitle">
      <span slot="help"></span>
      <div slot="right">
        <el-button
          size="small"
          :loading="loadingXls"
          @click="exportToExcel"
        >Выгрузить в XLSX
        </el-button>
      </div>
    </page-heading>


    <div>
      <el-table
        border
        style="width: 100%;"
        :data="users"
        empty-text="Нет пользователей"
        v-loading="loading"
      >
        <el-table-column width="200" label="Дирекция" prop="direction" ></el-table-column>
        <el-table-column width="200" label="Цех" prop="workshop" ></el-table-column>
        <el-table-column width="200" label="Личный номер" prop="persnum" ></el-table-column>
        <el-table-column width="200" label="ФИО" prop="full_name" ></el-table-column>
        <el-table-column width="200" label="Должность" prop="position" ></el-table-column>
        <el-table-column width="200" label="Категория" prop="category" ></el-table-column>
        <el-table-column width="200" label="Подразделение" prop="subdivision" ></el-table-column>
        <el-table-column width="200" label="Вышестоящее подразделение" prop="senior_subdivision" ></el-table-column>
        <el-table-column width="200" label="Бенд" prop="band" ></el-table-column>
        <el-table-column width="200" label="Разряд" prop="rank" ></el-table-column>
        <el-table-column width="200" label="Ставка" prop="rate" ></el-table-column>
        <el-table-column width="200" label="Система оплаты" prop="pay_system" ></el-table-column>
        <el-table-column width="200" label="График работы" prop="schedule" ></el-table-column>
        <el-table-column width="200" label="Оклад" prop="current_salary" ></el-table-column>
        <el-table-column width="200" label="% годовой премии" prop="year_bonus_percent" ></el-table-column>
        <el-table-column width="200" label="Вид приема" prop="hire_type" ></el-table-column>
        <el-table-column width="200" label="Дата приёма" prop="hire_date" ></el-table-column>
        <el-table-column width="200" label="Возраст" prop="age" ></el-table-column>
        <el-table-column width="200" label="Пол" prop="gender" v-slot="scope">
          {{ scope.row.gender ? 'М' : 'Ж' }}
        </el-table-column>
        <el-table-column width="200" label="Стаж в отрасли" prop="experience" ></el-table-column>
        <el-table-column width="200" label="Дата увольнения" prop="fire_date" ></el-table-column>
        <el-table-column width="200" label="Неактивен" prop="fired" v-slot="scope">
          {{ scope.row.fired ? 'Да' : 'Нет' }}
        </el-table-column>

      </el-table>
    </div>



    <paginator
      :paginator.sync="paginator"
      @page-changed="loadUsers"
    ></paginator>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import PageHeading from "@/components/PageHeading.vue";
import Paginator from "@/components/Paginator.vue";
import {paginator} from "@/mixins/paginator";
import {sorter} from "@/mixins/sorter";
import {downloader} from "@/mixins/downloader";

export default {
  name: 'UsersReport',
  components: {Paginator, PageHeading},
  mixins: [paginator, sorter, downloader],
  computed: {
    ...mapGetters(['user']),
    pageTitle() {
      return document.title;
    },
  },
  mounted() {
    this.loadUsers();
  },
  data() {
    return {
      loading: false,
      loadingXls: false,

      users: [],
    }
  },
  methods: {
    loadUsers() {
      this.loading = true;
      this.$api.user.search({
        [this.sorter.param]: this.sorter.sort,
        [this.paginator.param]: this.paginator.page,
        [this.paginator.paramPerPage]: this.paginator.perPage,
      })
        .then(({data, paginator, sorter}) => {
          this.users = data.users;
          this.paginatorFill(paginator);
          this.sorterFill(sorter);
        })
        .finally(() => {
          this.loading = false;
          this.loadStats();
        })
    },

    exportToExcel() {
      this.loadingXls = true;

      this.downloadFile(
        false,
        this.$api.exportImport.export,
        {
          entity: 'users',
          data: {
            smth: false
          }
        }
      )
        .finally(()=>{
          this.loadingXls = false;
        })
    },
  }
}
</script>

<style lang="scss">
.smz-base-table.successors-stats-table {
  text-align: center;
  border-collapse: collapse;

  th, td {
    padding: 1px 10px;
    border: 1px solid #b4b4b4;
    border-collapse: collapse;
  }

}

.successors-table-risk-cell-high {
  background-color: #ffe3e3 !important;
}
.successors-table-risk-cell-normal {
  background-color: #fff9e5 !important;
}
.successors-table-risk-cell-low {
  background-color: #e8ffe0 !important;
}
</style>